// extracted by mini-css-extract-plugin
module.exports = {"container":"lz-z","productName":"mz-z","modal":"nz-z","dimensions":"oz-z","recipientEmail":"pz-z","recommendedFit":"qz-z","hiddenField":"rz-z"};